import React from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 40,
    whiteSpace: 'pre-line',
  },
  title: {
    fontWeight: 800,
    fontSize: 18,
    marginBottom: 10,
  },
}))

// const des = `آزمون علایق گارنت برای درک شناخت و توانایی‌های خود برای انتخاب هوشمندانه
//  رشته‌ی تحصیلی و شغل در آینده مناسب است،
// این آزمون علایق شما را در 6 دسته‌بندی اصلی می‌سنجند.
// حتماً به سؤال‌ها همان‌طور که هستید پاسخ دهید نه آن‌طور که دوست دارید باشید، بهتر است
// از خانواده و والدین خود برای پاسخ به سؤالات مشورت بگیرید.
// `

const des = {
  1: `همه افراد با یکی از هوش‌ها مختلف به دنیا می‌آید و با اینکه نیاز به فعال‌کردن دارند، ولی همه‌جا هستند و از بدو تولد در وجود هر انسانی قرار داده شده‌اند. در این آزمون به شما نشان می‌دهیم که دقیقاً چه هوشی در شما قوی‌تر است.
  \t
  این آزمون ۸۰ سؤال دارد، باتوجه‌به شناختی که از خود دارید در طیف خیلی کم تا خیلی زیاد به سؤالات پاسخ دهید. به یاد داشته باشید که حتماً به سؤال‌ها همان‌طور که هستید پاسخ دهید نه آن‌طور که دوست دارید، بهتر است از خانواده و والدین خود برای پاسخ به سؤالات مشورت بگیرید.
  
 `,
  3: `آزمون علایق گارنت برای درک شناخت و توانایی‌های خود برای انتخاب هوشمندانه رشته‌ی تحصیلی و شغل در آینده مناسب است، این آزمون علایق شما را در 6 دسته‌بندی اصلی می‌سنجند.
 حتماً به سؤال‌ها همان‌طور که هستید پاسخ دهید نه آن‌طور که دوست دارید باشید، بهتر است از خانواده و والدین خود برای پاسخ به سؤالات مشورت بگیرید.
 `,
}

export default function Description({ data = {} }) {
  const classes = useStyles()
  console.log('examId', data?.id)

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        {/* {data.name} */}
        {data?.id === 1 ? 'راهنمای پاسخگویی به آزمون هوش گارنت' : 'راهنمای پاسخگویی به آزمون علایق گارنت'}
      </Typography>
      <Typography color="textSecondary" variant="body2">{data.description || des[data?.id]}</Typography>
      {/* <Typography color="textSecondary" variant="body2">
      {data.description || des[data.type]}</Typography> */}
    </div>
  )
}
